/* Scroll position restoration.
 *
 * Why this exists: collection grids are rendered client-side by the B4B app, so on
 * back/forward navigation the page is too short for the browser's native scroll
 * restoration to land in the right place — it falls back to the top. This saves the
 * scroll position per-URL and restores it once the page has rendered tall enough.
 *
 * Scope: restores only on back/forward and reload navigations (not fresh forward
 * navigations, which correctly start at the top). bfcache restores are left to the
 * browser. Revert: delete this file + its <script> include in layout/theme.liquid.
 */
(function () {
  if (!('scrollRestoration' in history)) return;
  history.scrollRestoration = 'manual';

  var PREFIX = 'mkp:scroll:';
  function key() { return PREFIX + location.pathname + location.search; }

  function save() {
    try { sessionStorage.setItem(key(), String(window.scrollY || window.pageYOffset || 0)); } catch (e) {}
  }

  // Save on hide (covers normal nav + mobile tab switching) and throttled on scroll.
  // NOTE: intentionally NOT using 'beforeunload' — it can disable bfcache, which would
  // make Back do a full reload instead of an instant restore. 'pagehide' is bfcache-safe.
  window.addEventListener('pagehide', save);
  var throttle = null;
  window.addEventListener('scroll', function () {
    if (throttle) return;
    throttle = setTimeout(function () { throttle = null; save(); }, 250);
  }, { passive: true });

  function navType() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type) return nav.type;
    } catch (e) {}
    if (performance.navigation) {
      if (performance.navigation.type === 2) return 'back_forward';
      if (performance.navigation.type === 1) return 'reload';
    }
    return 'navigate';
  }

  function restore() {
    var raw;
    try { raw = sessionStorage.getItem(key()); } catch (e) {}
    if (raw == null) return;
    var target = parseInt(raw, 10);
    if (!(target > 0)) return;

    var tries = 0;
    (function attempt() {
      tries++;
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (maxScroll >= target - 4 || tries > 40) {
        window.scrollTo(0, target);
        return; // done (page tall enough, or gave up after ~2s)
      }
      setTimeout(attempt, 50);
    })();
  }

  // bfcache restores (the common case for Back/Forward, especially on mobile): the page
  // is served from memory and its scripts are NOT re-executed, so this listener must be
  // attached unconditionally to catch them. Because scrollRestoration='manual' suppresses
  // the browser's own bfcache scroll restore, we restore here.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) restore();
  });

  // Fresh (non-bfcache) back/forward or reload loads.
  var type = navType();
  if (type === 'back_forward' || type === 'reload') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', restore);
    } else {
      restore();
    }
  }
})();
